import RulerControl from "@mapbox-controls/ruler";
import { useCallback, useEffect } from "react";
import { useControl, useMap } from "react-map-gl";
import { useQueryParam } from "@src/hooks/useQueryParam";

export const LandRuler = new RulerControl({
    units: "feet", // Set units to feet
    labelFormat: (n) => `${n.toFixed(2)} ft`, // Customize label format to show feet
    invisible: true, // Hide the control initially
    linePaint: {
        "line-color": "#0D99FF",
        "line-width": 4,
        "line-dasharray": [1, 1],
    },
    symbolPaint: {
        "text-color": "#fff",
        "text-halo-color": "#000",
        "text-halo-width": 2,
    },
    symbolLayout: {
        "text-size": 16,
    },
});

export function useMapRuler() {
    const maRef = useMap();
    const [isActiveQuery, setIsRulerActive, removeIsRulerActive] =
        useQueryParam<boolean>("ruler", null);

    const LandRulerComponent = useControl(() => {
        return LandRuler;
    });

    const activateRuler = useCallback(() => {
        LandRulerComponent.activate();
        setIsRulerActive(true);
    }, [LandRulerComponent, setIsRulerActive]);

    const deactivateRuler = useCallback(() => {
        LandRulerComponent.deactivate();
        removeIsRulerActive();
    }, [LandRulerComponent, removeIsRulerActive]);

    useEffect(() => {
        const map = maRef.current.getMap();
        map.on("style.load", () => {
            // Add the ruler to the map
            if (isActiveQuery && !LandRulerComponent.isActive) {
                activateRuler();
            }
        });

        // Remove the ruler when the query is removed
        if (!isActiveQuery && LandRulerComponent.isActive) {
            deactivateRuler();
        }
    }, [LandRulerComponent, activateRuler, deactivateRuler, isActiveQuery, maRef]);

    return {
        LandRuler: LandRulerComponent,
        isRulerActivated: LandRulerComponent.isActive,
        activateRuler,
        deactivateRuler,
    };
}
